import { useBlocker } from 'react-router';

import { ConfirmModal } from 'components/modal/ConfirmModal';

interface FormDirtyModalProps {
    dirty: boolean;
}

export function FormDirtyModal({ dirty }: FormDirtyModalProps) {
    const { state, proceed, reset } = useBlocker(dirty);

    return (
        <ConfirmModal
            open={state === 'blocked'}
            setOpen={() => {}}
            confirm={proceed}
            cancel={reset}
            text="Você tem informações não salvas, deseja ir mesmo assim?"
        />
    );
}
